// extracted by mini-css-extract-plugin
module.exports = {"neighborsList":"neighborsList__l3DUF","selected":"selected__2xcs_","neighborsContainer":"neighborsContainer__EPQV9","bordered":"bordered__1i9_p"};